import { Event } from "../Event";

export class UserSelectSectorEvents extends Event {
    public onChange = async (value: any, setField: any, setState: any, formValues: any) => {
        // console.log("Entreia aiojdasjiaojd ", value)

    }
}